import { z } from 'zod';

export const formSchema = z.object({
  workedQuantity: z.number({
    coerce: true,
    required_error: 'Informe a quantidade',
    invalid_type_error: 'Informe a quantidade',
  }).min(0, {
    message: 'A quantidade deve ser maior ou igual a zero',
  }),
});

export type FormSchema = z.infer<typeof formSchema>